import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import {
  Collapsible,
  CollapsiblePanel,
  CollapsibleContent,
} from '@americanexpress/dls-react';
import DisplayContactInfo from './DisplayContactInfo';

export const OneCommercialPaymentsEnrollmentFooter = (
  {
    languageData, locale,
  }) => Object.entries(languageData).length > 0 && (
  <IntlProvider locale={locale} messages={languageData}>
    <div className="flex flex-justify-between dls-white-bg">
      <span>
        <Collapsible
          className="dls-gray-03-bg"
          defaultOpen={[
            'collapsible-p-h2',
          ]}
        >
          <CollapsiblePanel
            id="collapsible-p-h1"
            className="dls-bright-blue dls-white-bg"
          >
            <div className="flex text-nowrap">
              <FormattedMessage id="help" />
            </div>
          </CollapsiblePanel>
          <CollapsibleContent labelledBy="collapsible-p-h1">
            <DisplayContactInfo />
          </CollapsibleContent>
        </Collapsible>
      </span>
      <span className="pad-1-tb pad-responsive-r dls-logo-line-sm">
        <img
          src="https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.24.1/package/dist/img/taglines/tagline-business-brightblue.svg"
          alt="tagline-business-brightblue"
        />
      </span>
    </div>
  </IntlProvider>
);

OneCommercialPaymentsEnrollmentFooter.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
};
export const loadModuleData = ({ store: { dispatch } }) => dispatch(loadLanguagePack('one-commercial-payments-enrollment-footer', { fallbackLocale: 'en-US' }));

OneCommercialPaymentsEnrollmentFooter.holocron = {
  name: 'one-commercial-payments-enrollment-footer',
  loadModuleData,
};
export default oneAppModuleWrapper('one-commercial-payments-enrollment-footer')(OneCommercialPaymentsEnrollmentFooter);
